import React, { useState } from "react";
import WizardModal from "../components/upload/WizardModal";

export default function UploadButton({ resetProducts }) {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
    // Se muestra el modal tras montarlo
    setTimeout(() => {
      document.getElementById("my_modal_5")?.showModal();
    }, 0);
  };

  return (
    <>
      {/* Botón flotante */}
      <div className="fixed bottom-4 right-4 z-50 flex items-center">
        <button
          onClick={openModal}
          className="p-3 rounded-full bg-green-500 text-white shadow hover:bg-green-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
        </button>
      </div>

      {/* Modal Wizard: only rendered if showModal is true */}
      {showModal && <WizardModal resetProducts={resetProducts} />}
    </>
  );
}
